<ng-container *transloco="let t">
  <div
    data-testid="asin-row"
    class="group relative flex w-full items-center gap-4 px-4 py-2"
    [ngClass]="{
      'bg-subtle': product().isSelected && !readonly(),
      'cursor-pointer': !readonly(),
      '[&:hover:not(:has([data-chevron]:hover))]:bg-subtle':
        !product().isSelected && !product().isDisabled && !readonly(),
      'cursor-not-allowed! opacity-75': product().isDisabled,
    }"
    (click)="onProductClick()"
  >
    @if (groupByParentAsin() && product().isParent) {
      <button
        iButton
        variant="ghost"
        size="icon-sm"
        data-chevron
        class="origin-center"
        [class.rotate-90]="openedParentAsin() === product().asin"
        (click)="$event.stopPropagation(); openParentAsin()"
      >
        <IIcon name="chevronRight" class="text-muted-foreground" />
      </button>
    }
    @if (!readonly()) {
      <div>
        <ICheckbox
          [value]="product().isSelected"
          [disabled]="product().isDisabled || (!product().isSelected && asinsLimitReached())"
          [indeterminate]="product().isIndeterminate"
          [iTooltip]="
            asinsLimitReached() && !product().isSelected ? t('asins-selection.limit_reached', [asinsLimit()]) : ''
          "
          data-testid="asin-item-checkbox"
        />
      </div>
    }
    <div
      class="relative flex size-10 items-center justify-center rounded-md duration-150"
      [ngClass]="[
        product().image ? 'border p-1 shadow-xs' : 'bg-subtle group-hover:ring-border-base p-2 group-hover:ring-1',
      ]"
    >
      @if (product().isParent) {
        <div
          class="absolute -top-1 -right-2 z-50 flex size-5 items-center justify-center rounded-full bg-gray-800 text-white"
        >
          <span class="text-xs font-medium">{{ product().childAsins?.length }}</span>
        </div>
      }
      @if (product().image) {
        <img [src]="product().image" class="size-9 rounded-md" />
      } @else {
        <IIcon name="package" class="text-muted-foreground" />
      }
    </div>
    <div class="flex flex-1 flex-col truncate">
      <span class="truncate select-none" data-testid="asin-item-title">{{ product().title ?? "--" }}</span>
      <div class="flex flex-row items-center gap-2">
        <span class="text-muted-foreground">{{ product().asin }}</span>
        @if (product().brand) {
          <div class="text-muted-foreground flex items-center gap-2">
            <span>•</span>
            <span>{{ product().brand }}</span>
          </div>
        }
        @if (product().ineligibleReason) {
          <span>•</span>
          <span class="text-warning" [iTooltip]="product().ineligibleReason">{{ t("common.ineligible") }}</span>
        }
        @if (product().isOtherCatalog) {
          <span>•</span>
          <span class="text-warning">{{ t("product-tracker.not_in_catalog") }}</span>
        }
        @if (product().isUnmanaged) {
          <span>•</span>
          <span class="text-warning" [iTooltip]="t('asin-selection-row.paused_product_tooltip')">{{
            t("asin-selection-row.paused_product")
          }}</span>
        }
      </div>
    </div>

    <div class="absolute top-2 right-2 flex items-center gap-2 opacity-0 group-hover:opacity-100">
      @if (product().isUnmanaged) {
        <button
          iButton
          variant="secondary"
          size="icon-sm"
          [iTooltip]="t('asin-selection-row.reactivate_product')"
          (click)="$event.stopPropagation(); restoreToManagedCatalog()"
        >
          <IIcon name="play" />
        </button>
      }
      <button
        iButton
        variant="secondary"
        size="icon-sm"
        [iTooltip]="t('common.copy_asin')"
        (click)="copyAsin(); $event.stopPropagation()"
      >
        <IIcon name="copyO" />
      </button>
      @if (!product().isOtherCatalog) {
        <a
          iButton
          variant="secondary"
          size="icon-sm"
          routerLink="/product-center/product360"
          target="_blank"
          [queryParams]="{ asin: product().asin }"
          queryParamsHandling="merge"
          [iTooltip]="t('parent-product-view-widget.view_in_product_360')"
          (click)="$event.stopImmediatePropagation()"
        >
          <IIcon name="binoculars" />
        </a>
      }
    </div>
  </div>
</ng-container>
